import { FC } from 'react'

import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { useTopDockHeight } from 'shared/components/MainLayout/hooks/useTopDockHeight'
import { MainLayout } from 'src/shared/components'

import { DownloadCenterDetailPage } from './pages/DownloadCenterDetailPage/DownloadCenterDetailPage'
import { DownloadCenterListPage } from './pages/DownloadCenterListPage/DownloadCenterListPage'

export const DownloadCenterRouter: FC = () => {
  const { height: topDockHeight, topDockRef } = useTopDockHeight()
  const navigate = useNavigate()
  const { apps: availableApps } = useAvailableApps()

  return (
    <MainLayout
      topDockHeight={topDockHeight}
      topDockRef={topDockRef}
      handleAppClick={app => {
        if (
          Object.values(availableApps).some(
            availableApp =>
              availableApp.id === app.id && availableApp.isDisabled
          )
        ) {
          return
        }

        if (!app.url) return

        const relativePath = app.url.replace(
          process.env.REACT_APP_CONTAINER_DOMAIN!,
          ''
        )
        navigate(relativePath)
      }}
    >
      <Routes>
        <Route path='/' element={<DownloadCenterListPage />} />
        <Route path='/:appId' element={<DownloadCenterDetailPage />} />
      </Routes>
    </MainLayout>
  )
}
